import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Button, Col, Row } from "reactstrap";
import SVG from "../../utils/CommonSvgIcon/SVG";
import H3 from "../Headings/H3Element";
import { ArrowLeft } from "react-feather";

export interface propsTypes {
  mainTitle?: string;
  parent?: string;
  title: string;
  to?: any;
  onClickLink?: () => void;
  showBack?: boolean;
}

const Breadcrumbs = ({ mainTitle, parent, title, to, onClickLink, showBack }: propsTypes) => {
  const navigate = useNavigate();

  return (
    <Col xs="12">
      <div className="page-title">
        <Row>
          <Col sm="6" className="ps-0 d-flex align-items-center">
            {showBack && (
              <Button 
                onClick={() => navigate(to || -1)} 
                color="primary"
                className="d-flex align-items-center justify-content-center me-2" 
                style={{ width: '38px', height: '38px', borderRadius: '8px', padding: '0' }}
              >
                <ArrowLeft size={20} />
              </Button>
            )}
            <H3>{mainTitle}</H3>
          </Col>
          <Col sm="6" className="pe-0">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={`/dashboard`}>
                  <SVG iconId="stroke-home" className="stroke-icon" />
                </Link>
              </BreadcrumbItem>
              {parent && to && (
                <BreadcrumbItem>
                  <Link onClick={onClickLink} to={to}>{parent}</Link>
                </BreadcrumbItem>
              )}
              <BreadcrumbItem className="active">{title}</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Breadcrumbs;
